export enum RoundBracket {
  LEFT = '(',
  RIGHT = ')',
}

export enum SquareBracket {
  LEFT = '[',
}
